/**
 * Module to wrapp Hashing features, currently using a 3rd party library
 * If we decide to change the library or doing it in house, we can do it here
 *
 */

import HashLib from 'hash.js';

import * as DataDogLogs from '~/lib/datadog/datadog';

/**
 * Syncronously function to hash text using sha256
 *
 * @param {string} textToHash
 * @returns
 */
const hashText = (textToHash) => {
  try {
    return HashLib.sha256().update(textToHash).digest('hex');
  } catch (error) {
    DataDogLogs.error('[Allbirds utils] - hashText - Error hashing text', {}, error);
  }
};

export { hashText };
